import * as types from "./types";
import { getCitationInfo, isFetching } from "./selectors";
import JigsawAPI from "../../services/jigsaw";

export const getBookCitationBegin = (isbn) => ({
  type: types.GET_BOOK_CITATION_REQUEST,
  isbn,
});

export const getBookCitationFinish = (isbn, citationInfo) => ({
  type: types.GET_BOOK_CITATION_SUCCESS,
  isbn,
  citationInfo,
});

export const getBookCitationError = (isbn) => ({
  type: types.GET_BOOK_CITATION_ERROR,
  isbn,
});

export const getBookCitationInfo = (isbn) => async (dispatch, getState) => {
  if (!isFetching(getState(), isbn)) {
    let citationInfo = getCitationInfo(getState(), isbn);

    // should probably handle the error case
    if (!citationInfo) {
      dispatch(getBookCitationBegin(isbn));
      citationInfo = await JigsawAPI.getCitationInfo(isbn);
    }

    return dispatch(getBookCitationFinish(isbn, citationInfo));
  }
};
